import styled, { css } from 'styled-components';
import { themeGet } from '../../../foundation/theme/themeGet/get.js';

var TableHead = styled.thead.withConfig({
  displayName: "TableHead",
  componentId: "sc-kjrz0r-0"
})(["", ";"], function (_ref) {
  var _ref$$stickyHeader = _ref.$stickyHeader,
    $stickyHeader = _ref$$stickyHeader === void 0 ? false : _ref$$stickyHeader;
  return $stickyHeader && css(["position:sticky;top:0;z-index:1;background-color:", ";box-shadow:", ";"], themeGet('colors.background.50'), themeGet('dropShadow.300'));
});

export { TableHead };
